export default () => <span> | </span>